import { Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { FormatGitInfoProps } from "./FormatGitInfo.types";
import { formatDateWithTime } from "@/src/lib/formatDateWithTime/formatDateWithTime";

export const FormatGitInfo = ({ gitInfo, title }: FormatGitInfoProps) => {
    const { t } = useTranslation("common", {
        keyPrefix: "format-git-info",
    });

    if (!gitInfo) {
        return null;
    }

    const gitHash = gitInfo.git.commit.id.full.slice(0, 7);
    const gitTime = formatDateWithTime(gitInfo.git.commit.time);
    const buildTime = formatDateWithTime(gitInfo.git.build.date);
    const branch = gitInfo.git.branch;

    const data = [
        {
            label: t("git-hash"),
            value: gitHash,
        },
        {
            label: t("git-branch"),
            value: branch,
        },
        {
            label: t("git-time"),
            value: gitTime,
        },
        {
            label: t("build-time"),
            value: buildTime,
        },
    ];

    return (
        <Stack spacing={1}>
            <Typography variant="h4">{title}</Typography>
            <Grid container rowSpacing={0.5}>
                {data.map((item) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={item.label}>
                        <Typography variant="body2" color="text.secondary">
                            {item.label}:
                        </Typography>
                        <Typography variant="body1">{item.value}</Typography>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default FormatGitInfo;
